import React, {useEffect, useState} from "react";
import api from "../api/axiosInstance";
import ProductFormModal from "../components/ProductFormModal";
import {Button} from "../components/Button";
import {EnterSkuModal} from "../components/skuProdigiModal";

export default function ProdigiProductsPage() {
    const [products, setProducts] = useState([]);
    const [pagination, setPagination] = useState({page: 1, pages: 1, total: 0});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingProduct, setEditingProduct] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isEnterSkuOpen, setIsEnterSkuOpen] = useState(false);

    const fetchProducts = async (page = 1) => {
        setIsLoading(true);
        try {
            const resp = await api.get("/admin/products/search", {
                params: {
                    supplier: "prodigi",
                    page,
                    limit: 20,
                }
            });
            const {products: prods, pagination: pag} = resp.data;
            setProducts(prods);
            setPagination(pag);
        } catch (err) {
            console.error("Failed to fetch prodigi products:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts(1);
    }, []);

    const handleAddClick = () => {
        setEditingProduct(null);
        setIsEnterSkuOpen(true);
    };

    const handleEditClick = (product) => {
        setEditingProduct(product);
        setIsModalOpen(true);
    };

    const handleSkuEntered = async (sku) => {
        setIsEnterSkuOpen(false);
        try {
            const resp = await api.get("/admin/products/prodigi", {
                params: {sku},
            });
            if (resp.data.success) {
                const pd = resp.data;
                const product = {
                    sku: pd.sku,
                    supplier: "prodigi",
                    title: "",
                    description: pd.description || "",
                    details: [],
                    priceofstock: pd.pricing.totalCost.amount,
                };
                setEditingProduct(product);
            } else {
                setEditingProduct({sku, supplier: "prodigi"});
            }
        } catch (err) {
            console.error("Error fetching prodigi by SKU:", err);
            setEditingProduct({sku, supplier: "prodigi"});
        }
        setIsModalOpen(true);
    };

    const handleSave = async (productData) => {
        try {
            if (editingProduct && editingProduct._id) {
                await api.put(`/admin/products/${editingProduct._id}`, productData);
            } else {
                await api.post("/admin/products", productData);
            }
            closeModal();
            fetchProducts(pagination.page);
        } catch (err) {
            console.error("Failed to save product:", err);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setEditingProduct(null);
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Prodigi Products</h1>
                <Button className="btn btn-primary" onClick={handleAddClick}>Add Prodigi Product</Button>
            </div>

            <table className="min-w-full border">
                <thead>
                <tr>
                    <th>SKU</th>
                    <th>Title / Desc</th>
                    <th>Supplier</th>
                    <th>Prodigi Info</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {isLoading ? (
                    <tr>
                        <td colSpan={5}>Loading…</td>
                    </tr>
                ) : products.length === 0 ? (
                    <tr>
                        <td colSpan={5}>No products found</td>
                    </tr>
                ) : (
                    products.map((p) => (
                        <tr key={p._id || p.sku}>
                            <td>{p.sku}</td>
                            <td>{p.title || p.description}</td>
                            <td>{p.supplier}</td>
                            <td>
                                {p.prodigiDimensions
                                    ? `${p.prodigiDimensions.width} × ${p.prodigiDimensions.height} ${p.prodigiDimensions.units}`
                                    : ""}
                            </td>
                            <td>
                                <Button
                                    className="btn btn-sm mr-2"
                                    onClick={() => handleEditClick(p)}
                                >
                                    View / Edit
                                </Button>
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </table>

            {pagination && (
                <div className="mt-4 flex justify-center gap-2">
                    <Button
                        disabled={pagination.page <= 1}
                        onClick={() => fetchProducts(pagination.page - 1)}
                    >
                        Previous
                    </Button>
                    <span>Page {pagination.page} / {pagination.pages || pagination.pageCount}</span>
                    <Button
                        disabled={pagination.page >= (pagination.pages || pagination.pageCount)}
                        onClick={() => fetchProducts((pagination.page || 1) + 1)}
                    >
                        Next
                    </Button>
                </div>
            )}

            <ProductFormModal
                open={isModalOpen}
                onClose={closeModal}
                onSubmit={handleSave}
                product={editingProduct}
            />

            <EnterSkuModal
                open={isEnterSkuOpen}
                onSubmit={handleSkuEntered}
                onClose={() => setIsEnterSkuOpen(false)}
            />
        </div>
    );
}
